import { render } from "./TopBarPage.vue?vue&type=template&id=710c02d8&scoped=true"
import script from "./TopBarPage.vue?vue&type=script&lang=js"
export * from "./TopBarPage.vue?vue&type=script&lang=js"

import "./TopBarPage.vue?vue&type=style&index=0&id=710c02d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710c02d8"]])

export default __exports__